import { useState } from 'react'
import { logger } from '../helpers/logger/logger'
// import { Protocol } from '@orbitalgaming/games-frontend-library'
// import settingsPost from '../socket/globalMessages'
// declaration
export let settings: any = {
  stake: '0.00',
  over_or_under: '0',
  bankroll: '50',
  audio: {
    sound: '50',
    music: '50',
    isMusicOff: false,
    isSoundOff: false,
  },
  configOne: {
    stake: '0',
    rollAmount: '0',
    onWin: true,
    onWinPercent: '100',
    onLoss: true,
    onLossPercent: '100',
    stopOnLoss: '0',
    stopOnWin: '0',
    maxStake: '0',
    rollNumber: '50',
    rollUnder: '0',
    isSaved: '0',
  },
  configTwo: {
    stake: '0',
    rollAmount: '0',
    onWin: true,
    onWinPercent: '100',
    onLoss: true,
    onLossPercent: '100',
    stopOnLoss: '0',
    stopOnWin: '0',
    maxStake: '0',
    rollNumber: '50',
    rollUnder: '0',
    isSaved: '0',
  },
  configThree: {
    stake: '0',
    rollAmount: '0',
    onWin: true,
    onWinPercent: '100',
    onLoss: true,
    onLossPercent: '100',
    stopOnLoss: '0',
    stopOnWin: '0',
    maxStake: '0',
    rollNumber: '50',
    rollUnder: '0',
    isSaved: '0',
  },
}
let setsettings: any
let globalSocketMessages: any
// initialization

export const useSettings = (func: any) => {
  return (
    ([settings, setsettings] = useState<any>(settings)),
    (globalSocketMessages = func)
  )
}
// getter
export const getSettings = () => settings

export const sendStakes = (
  stake: any,
  bankroll: any,
  over_or_under: any,
  settings: any,
) => {
  globalSocketMessages.settingsPost({
    ...settings,
    stake,
    bankroll,
    over_or_under,
  })
}

export const sendAudio = (audio: any, settings: any) => {
  const sound = audio.sound
  const music = audio.music
  const isMusicOff = audio.isMusicOff
  const isSoundOff = audio.isSoundOff
  globalSocketMessages.settingsPost({
    ...settings,
    audio: { sound, music, isMusicOff, isSoundOff },
  })
}

export const sendConfigs = (
  configOne: any,
  configTwo: any,
  configThree: any,
  settings: any,
) => {
  logger.log({ settings })
  globalSocketMessages.settingsPost({
    ...settings,
    configs: { configOne, configTwo, configThree },
  })
}
